export default function (ctx) {
  if (process.server) {// TOOD: build something cool here once the app sends unique headers from its webviews
  }
}